import { EMPTY_ARRAY } from 'commons-ui';

import { DASHBOARD_RESOURCES } from 'constant';
import usePermission from 'commons-ui/src/permission/usePermission';
import { FINANCE_RESOURCES } from '../../helper';

export const makeActionList = () => {
	const { hasPermission } = usePermission();
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						configPageName: DASHBOARD_RESOURCES.finance,
						configResourceName: FINANCE_RESOURCES.paymentPgFailure,
						configActionName: 'updatePaymentPGFailureData'
					});
				}
			}
		],

		bulkActions: EMPTY_ARRAY
	};
};

export default {
	makeActionList
};
